namespace advisorop.domains {

    export enum LifeCycleActivityStatus {
        UNCLAIMED = 0,
        CLAIMED = 1,
        COMPLETED = 2,
        SKIPPED = 3,
    }

    export enum AccActivtyId {
        INITIATE_PROPOSAL = 10,
        APP_PREPARE_SEND = 15,
        APP_RECEIVE_SUBMIT = 20,
        ACCT_OPEN = 25,
        ACCT_LINKED = 30,
        ACCT_FUNDED = 35,
        ACCT_INVESTED = 40,
        ACCT_BILLING_SETUP = 45,
        FOLLOWUP_ADVISOR_CLIENT = 50,
        ARCHIVE = 55    // Initial client does not want the archive step, so the prior step will be marked as 'final', but we will keep this enum for the future
    }

    export interface AccountLifeCycleViewModel {
        id: number;

        activityId: number;

        activityName: string;

        activityStatus: LifeCycleActivityStatus;

        activityStatusDesc: string;

        startDate: Date | string | null;

        endDate: Date | string | null;

        dateCreated: Date | string | null;

        canClaim: boolean;

        responsibleUserId: string;

        responsibleUserName: string;

        notes: string;

        ordNo: number;

        // set by Complete / Skip: this account has finished its workflow and has come off
        // the App Tracker, so the grid can drop its row
        accountArchived: boolean;

        // other steps closed by the same action, so the grid can show them straight away
        alsoUpdated: AccountLifeCycleViewModel[];

        // only for client side needs
        fieldIndex: number;
    }

    export interface IAppTrackerData {
        
        isCompleted: boolean;

        advisorId: string;

        advisorName: string;

        accountId: number;

        accountName: string;

        accountNumber: string;

        accountStatus: number;

        householdId: number | null;

        householdName: string;

        proposedAmount: number | null;

        activities: AccountLifeCycleViewModel[];
    }
}